export var IOpenModalAction;
(function (IOpenModalAction) {
    let IOpenBrandSampleModal;
    (function (IOpenBrandSampleModal) {
        /**
         * Return an instance of IOpenBrandSampleModal with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IOpenBrandSampleModal.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IOpenBrandSampleModal = IOpenModalAction.IOpenBrandSampleModal || (IOpenModalAction.IOpenBrandSampleModal = {}));
    let IOpenEcoFriendlyDefinitionModal;
    (function (IOpenEcoFriendlyDefinitionModal) {
        /**
         * Return an instance of IOpenEcoFriendlyDefinitionModal with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IOpenEcoFriendlyDefinitionModal.build = (partial) => (Object.assign({ images: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IOpenEcoFriendlyDefinitionModal = IOpenModalAction.IOpenEcoFriendlyDefinitionModal || (IOpenModalAction.IOpenEcoFriendlyDefinitionModal = {}));
    let IOpenSduiModal;
    (function (IOpenSduiModal) {
        /**
         * To shift away from any client side template enum, we have 2 enums to determine:
         * ModalType: the type of modal to open on the client. For now, we only have the standard popup modal
         * ModalIdentifier: the content of the modal to fetch, this will be returned to BE in a different API to fetch the content
         */
        let ModalType;
        (function (ModalType) {
            ModalType["MODAL_TYPE_UNKNOWN"] = "MODAL_TYPE_UNKNOWN";
            ModalType["FUNCTIONAL_MODAL"] = "FUNCTIONAL_MODAL";
            ModalType["MARKETING_MODAL"] = "MARKETING_MODAL";
        })(ModalType = IOpenSduiModal.ModalType || (IOpenSduiModal.ModalType = {}));
        let ModalIdentifier;
        (function (ModalIdentifier) {
            ModalIdentifier["MODAL_IDENTIFIER_UNKNOWN"] = "MODAL_IDENTIFIER_UNKNOWN";
        })(ModalIdentifier = IOpenSduiModal.ModalIdentifier || (IOpenSduiModal.ModalIdentifier = {}));
        /**
         * Return an instance of IOpenSduiModal with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IOpenSduiModal.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IOpenSduiModal = IOpenModalAction.IOpenSduiModal || (IOpenModalAction.IOpenSduiModal = {}));
    /**
     * Return an instance of IOpenModalAction with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IOpenModalAction.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IOpenModalAction || (IOpenModalAction = {}));
